// @flow
import React from "react"
import { compose, type HOC, withStateHandlers } from "recompose"
import withUser from "hoc/withUser"
import withQuery from "hoc/withQuery"
import withOnMount from "hoc/withOnMount"
import withConnect from "hoc/withConnect"
import SubPage from "pages/_Page/SubPage"
import { trackProductView } from "analytics/product/analyticsTraits"
import urls from "data/router/urls"
import { clearProduct } from "data/search/actions"
import type { ID } from "data/enums/types"
import { listProductVariantsQuery } from "data/product/graphql/queries"
import Mobile from "components/Media/Mobile"
import Desktop from "components/Media/Desktop"
import { Flex } from "componentsStyled/Layout/Flex"
import { Container } from "componentsStyled/Layout/Containers"
import Select from "components/Select"
import { Text } from "componentsStyled/Typography/Texts"
import { Title } from "componentsStyled/Typography/Titles"
import AffiliateName from "components/AffiliateName"
import {
  Space
} from "componentsStyled/Layout/Spacers"
import Detail from "./Detail"
import Gallery from "./Gallery"
import { Half } from "./styled"
import { DetailWrap } from "./Detail/styled"

/**
 * Page to show a product and its variants offered by an affiliate.
 * User gets to select the variant and create a reservation.
 */
const Product = ({ data, selectedVariantId, match, user, onSelectVariant }) => {
  if (data.productVariants.length === 0) {
    return null
  }
  const representativeVariant = data.productVariants[0]
  const representativeProduct = representativeVariant.product
  const representativeAffiliate = data.affiliate

  const variantOptions = data.productVariants.map(productVariant => ({
    id: productVariant.id,
    name: productVariant.name,
  }))

  const selectedVariant = data.productVariants.find(productVariant => {
    return productVariant.id === selectedVariantId
  })

  const content = <React.Fragment>
    <DetailWrap>
      <Text bigOnDesktop>{representativeProduct.manufacturer.name}</Text>
      <Title>{representativeProduct.name}</Title>
      <AffiliateName name={representativeAffiliate.name} />
      <Space />
      <Select
        onChange={(variantId) => {
          // HACK(ray): Workaround for the `Select` component calling back with a string id
          onSelectVariant(typeof(variantId) === 'number' ? variantId : Number(variantId))
        }}
        options={variantOptions}
        value={selectedVariantId}
      />
      <Space />
      {selectedVariant &&
        <Detail
          productVariant={selectedVariant}
          variantAffiliate={selectedVariant.affiliates[0]}
          user={user}
        />
      }
    </DetailWrap>
  </React.Fragment>

  return (
    <SubPage title={representativeProduct.name} backUrl={urls.products}>
      <Gallery images={representativeProduct.images} />
      <Mobile>
        {content}
      </Mobile>
      <Desktop>
        <Container>
          <Flex>
            <Half />
            <Half white>
              {content}
            </Half>
          </Flex>
        </Container>
      </Desktop>
    </SubPage>
  )
}

type Outter = {|
  match: {|
    params: {|
      productId: ID,
      affiliateId: ID,
    |},
  |},
|}

const mapDispatchToProps = {
  clearProduct,
}

const enhancer: HOC<*, Outter> = compose(
  withUser(),
  withQuery(listProductVariantsQuery, {
    variables: props => ({
      productId: props.match.params.productId,
      affiliateId: props.match.params.affiliateId,
    }),
  }),
  withStateHandlers(
    (props) => ({
      selectedVariantId: props.data.productVariants[0].id
    }),
    {
      onSelectVariant: (state, props) => variantId => {
        const variant = props.data.productVariants.find(variant => variant.id === variantId)
        if (variant) {
          trackProductView(variant, props.user)
        }
        return {
          selectedVariantId: variantId
        }
      }
    }
  ),
  withConnect(() => ({}), mapDispatchToProps),
  withOnMount(props => {
    trackProductView(props.data.productVariants[0], props.user)
    props.clearProduct()
  }),
)

export default enhancer(Product)



// WEBPACK FOOTER //
// ./src/pages/Product/index.js